import React from 'react';

import { Box, TextField } from '@mui/material';
import _ from 'lodash';

import FilterPaper from '../../common/filter_paper';

const SuppliersFilters = ({ onSearchInputChange }) => {
    const onSearchInputChangeDebounced = _.debounce((value) => onSearchInputChange(value), 600);

    return (
        <FilterPaper title="Filtry zaopatrzeniowców">
            <Box sx={ { display: 'flex', gap: 2, alignItems: 'center' } }>
                <TextField
                    size="small"
                    label="Szukaj po imieniu lub nazwisku"
                    sx={ { maxWidth: 400, width: '100%' } }
                    onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                />
            </Box>
        </FilterPaper>
    );
};

export default SuppliersFilters;